module.exports = __webpack_public_path__ + "static/media/twitter.987bcc88.svg";